class LoadOnScroll extends HTMLElement {
  constructor() {
    super();
    this.posterSrc = this.getAttribute('poster');
    this.videoElement = this.getAttribute('video-element');
    this.videoLoaded = false;
    this.intersectionObserver = null;

    this.boundLoadVideo = this.loadVideo.bind(this);
    
    this.init();
  }
  
  init() {
    this.innerHTML = `
      <img src="${this.posterSrc}" alt="" loading="lazy" style="width: 100%; height: 100%;">
    `;

    this.setupIntersectionObserver();
    this.checkIfInViewport();
    
    window.addEventListener('scroll', this.boundLoadVideo, { once: true, passive: true });
    window.addEventListener('touchstart', this.boundLoadVideo, { once: true, passive: true });
    window.addEventListener('mousedown', this.boundLoadVideo, { once: true, passive: true });
  }
  
  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '100px',
      threshold: 0.1
    };

    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.videoLoaded) {
        this.loadVideo();
      }
    }, options);

    this.intersectionObserver.observe(this);
  }
  
  checkIfInViewport() {
    const rect = this.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    if (
      rect.top <= windowHeight &&
      rect.bottom >= 0 &&
      !this.videoLoaded
    ) {
      this.loadVideo();
    }
  }
  
  loadVideo() {
    if (this.videoLoaded) return;
    
    this.videoLoaded = true;
    this.innerHTML = this.videoElement;
    
    window.removeEventListener('scroll', this.boundLoadVideo);
    window.removeEventListener('touchstart', this.boundLoadVideo);
    window.removeEventListener('mousedown', this.boundLoadVideo);
  }
  
  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    window.removeEventListener('scroll', this.boundLoadVideo);
    window.removeEventListener('touchstart', this.boundLoadVideo);
    window.removeEventListener('mousedown', this.boundLoadVideo);
  }
}

customElements.define('load-on-scroll', LoadOnScroll);